import { IActionWithPayload } from "store/helper";

import { IEntityFetchSuccess, RequestAction } from "../actions";

import { RECURLY, RecurlyActionNames, RecurlyActionTypes } from "./actions";
import { IRecurlyCoupon } from "./interfaces";

export interface IRecurlyState {
  coupon: IRecurlyCoupon | null;
  newCoupon: IRecurlyCoupon | null;
  shouldFetchActiveCoupon: boolean;
}

export const initialState: IRecurlyState = {
  coupon: null,
  newCoupon: null,
  shouldFetchActiveCoupon: true,
};

const recurlyReducer = (state: IRecurlyState = initialState, action: RecurlyActionTypes): IRecurlyState => {
  switch (action.type) {
    case RecurlyActionNames.CHECK_RECURLY_COUPON_SUCCESS: {
      const { payload } = action as IActionWithPayload<string, IEntityFetchSuccess<IRecurlyCoupon>>;
      return {
        ...state,
        newCoupon: payload.value,
      };
    }

    case RecurlyActionNames.CHECK_RECURLY_COUPON_FAILURE: {
      return {
        ...state,
        newCoupon: null,
      };
    }

    case RECURLY.COUPONS[RequestAction.SUCCESS]: {
      const { payload } = action as IActionWithPayload<string, IEntityFetchSuccess<IRecurlyCoupon>>;
      return {
        ...state,
        coupon: payload.value,
        shouldFetchActiveCoupon: false,
      };
    }

    case RECURLY.COUPONS[RequestAction.FAILURE]: {
      return {
        ...state,
        newCoupon: null,
        shouldFetchActiveCoupon: false,
      };
    }

    case RecurlyActionNames.COUPON_REDEEMED: {
      return initialState;
    }

    default:
      return state;
  }
};

export default recurlyReducer;
